import { useState, useEffect, useCallback } from 'react';
import { getCostCategories } from '../api/jobCosts';
import type { CostCategory } from '../types/jobCost';

/**
 * Hook for fetching cost categories
 */
export function useCostCategories() {
  const [data, setData] = useState<CostCategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const categories = await getCostCategories();
      setData(categories);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch cost categories');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchCategories,
  };
}
